import { clone, map } from 'lodash';
import { today } from '../utils/dates';
import { Segment } from './segment';
import { StrategyPicture } from './strategy-picture';
import { Pipe, PipeTransform } from '@angular/core';

class Translation {
  name: any = {};
  description: any = {};
  legal_terms: any = {};
  application_url: any = {};
}

@Pipe({
  name: 'allstrategypictures'
})
export class AllStrategyPicturesPipe implements PipeTransform {
  transform(strategy: Strategy): { picture: any, illustration_usage_name: string }[] {
    return Strategy.allStrategyPictures(strategy);
  }
}

export class Strategy {
  id = '';
  name = '';
  status = '';
  start_date = null;
  reference = '';
  publication_date = today('UTC').toISOString();
  created_at = '';
  end_date = null;
  pictures: StrategyPicture[] = [];
  picture: any;
  is_activated = true;
  legal_terms: string;
  brand: any = null;
  or_targeting_filters: any = [];
  and_targeting_filters: any = [];
  is_targeted: boolean = null;
  audience_lookalike_id: string = null;
  audience_type: string = null;
  user: any;
  application_url = null;
  application_channel = 'BOTH';
  acceptation_status = 'AVAILABLE';
  playground: any = {};
  commissions: any = [];
  commissions_min_max: any = {};
  proposed_vouchers: any = [];

  cost_per_acquisition = 5;
  commission_rate = 30;
  total_consumed = 0;
  min_amount = null;
  max_amount = null;
  max_limit_transaction_amount = null;
  capping = null;
  capping_period = null;
  budget = null;
  completion: any = null;
  animation_delay_days = 0;
  total_consumers = 0;
  funded_by: string;
  objective = 'TARGET_ALL';
  targeting_is_valid = true;
  stores = [];
  logo: {};
  reward: any;
  highlight_level: string;
  description: string;
  segments: Segment[];
  translation = new Translation();
  voucher_values: any = {};

  static allStrategyPictures(strategy): { picture: any, illustration_usage_name: string }[] {
    if (!strategy) {
      return [];
    }
    return [...strategy.pictures];
  }

  is_audience_targeted: boolean = false;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);

    this.is_audience_targeted = this.is_targeted || !!this.audience_lookalike_id;
    this.trimTimezoneFromDates();
  }

  getActiveStatus() {
    if (this.is_activated && new Date(this.start_date) > new Date()) {
      return 'NOT_STARTED';
    }

    if (this.is_activated && new Date(this.end_date) < new Date()) {
      return 'ENDED';
    }

    if (this.is_activated && new Date(this.start_date) <= new Date()) {
      return 'ACTIVE';
    }

    if (!this.is_activated) {
      return 'INACTIVE';
    }

    return '';
  }

  trimTimezoneFromDates() {
    ['start_date', 'end_date', 'publication_date'].forEach((key) => {
      const value = this[key];

      if (value) {
        this[key] = value.substring(0, 19) + 'Z';
      }
    });
  }

  getSegmentList(separator = ', ') {
    return map(this.segments, 'name').join(separator);
  }
}

export function toApi(data) {
  data = clone(data);

  delete data.created_at;
  delete data.updated_at;

  if (data.logo && data.logo.id) {
    data.logo = data.logo.id;
  }

  if (data.user && data.user.id) {
    data.user = data.user.id;
  }

  if (data.merchant && data.merchant.id) {
    data.merchant = data.merchant.id;
  }

  if (data.brand && data.brand.id) {
    data.brand = data.brand.id;
  }

  if (data.segments) {
    data.segments = map(data.segments, 'id');
  }

  if (data.start_date) {
    const startDate = new Date(data.start_date);
    startDate.setUTCHours(0, 0, 0, 0);
    data.start_date = startDate;
  }

  if (data.end_date) {
    const endDate = new Date(data.end_date);
    endDate.setUTCHours(23, 59, 59, 999);
    data.end_date = endDate;
  }

  if (!data.application_url) {
    data.application_url = null;
  }

  return data;
}

